import React from 'react';
import PersonalizedNutrientProfileLabels from './PersonalizedNutrientProfileLabels';
import PersonalizedNutrientProfileRows from './PersonalizedNutrientProfileRows';

const PersonalizedNutrientProfile = (props) => {
  const {heading, labels, products, nutrients} = props.data;

  return (
    <div className="nppe2-fc-personalized-nutrient-profile" id="fc-screenshot-feeding-guidelines-personalized-nutrient-profile">
      <div className="row">

        <div className="col-xs-12 nppe2-fc-sub-title-output">
          {heading}
        </div>

        <div className="nppe2-fc-personalized-nutrient-profile__item">
          <table>
            <PersonalizedNutrientProfileLabels
              data={labels}
            />
            
            <tbody>
              {nutrients.map((nutrient, index) => (
                <tr key={index}>
                  <td>
                    {nutrient.nutrient}
                  </td>

                  <td>
                    {formatNutrientOutput(nutrient.asFed)}
                  </td>

                  <td>
                    {formatNutrientOutput(nutrient.dryMatter)}
                  </td>

                  <td>
                    {formatNutrientOutput(nutrient.per100kcal)}
                  </td>

                  <td>
                    {formatNutrientOutput(nutrient.perMj)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        
      </div>
    </div>
  );
}

const formatNutrientOutput = (input) => {
  return (typeof input !== "number" ? "" : input.toFixed(2));
}

export default PersonalizedNutrientProfile;
